import { Component, Input, OnInit } from "@angular/core";
import { NotificationService } from "../../services/notification.service";
import { EMPTY, interval, switchMap, takeUntil, takeWhile, tap } from "rxjs";
import { iconType, notificationType } from "./notification.model";
import { UnsubscribeService } from "src/app/services/unsubscribe.service";

const ICONS_ARRAY = ["icon-1", "icon-2", "icon-3", "icon-4", "icon-5", "icon-6", "icon-7", "icon-8"];

@Component({
	selector: "app-notification",
	templateUrl: "./notification.component.html",
	styleUrls: ["./notification.component.scss"],
	providers: [UnsubscribeService],
})
export class NotificationComponent implements OnInit {
	@Input() notificationType: notificationType = null;
	@Input() icon: iconType = "icon-1";

	icons = ICONS_ARRAY;
	progress = 100;

	constructor(
		public notificationService: NotificationService,
		private unsubscribe$: UnsubscribeService
	) {}

	ngOnInit() {
		this.notificationService.isNotificationShow$
			.pipe(
				takeUntil(this.unsubscribe$),
				switchMap((res) => {
					return res ? this.startProgressBar() : EMPTY;
				})
			)
			.subscribe();
	}

	hideNotification() {
		this.notificationService.hideNotification();
		this.resetProgressBar();
	}

	startProgressBar() {
		this.progress = 100;
		const intervalTime = 100;
		const duration = 5000;
		const step = 100 / (duration / intervalTime);

		return interval(intervalTime).pipe(
			tap(() => {
				this.progress -= step;
				if (this.progress <= 0) {
					this.hideNotification();
				}
			}),
			takeWhile(() => this.progress > 0)
		);
	}

	resetProgressBar() {
		this.progress = 100;
	}

	isString(value: string | string[]): value is string {
		return typeof value === "string";
	}

	isArray(value: string | string[]): value is string[] {
		return Array.isArray(value);
	}
}
